import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { baseUrl } from '../../../env';
import axios from 'axios';

const ConfirmInvitationPage = () => {
    const { tokenSalt } = useParams();

    const validateToken = async () => {
        try {
            const res = await axios.get(
                `${baseUrl}/auth/invitation/validate/${tokenSalt}`
            );
            console.log(res.data);
        } catch (error) {
            console.log('error', error);
        }
    };

    useEffect(() => {
        validateToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return <h1>Confirm Invitation</h1>;
};

export default ConfirmInvitationPage;
